import * as React from 'react';
import { observer } from 'mobx-react-lite';
import ItemTileView, { ItemTileViewPropsBase } from './ItemTileView';

const styles = require('./FilePickerTileViewCommon.scss');
const classNames = require('classnames');

export interface FolderTileViewProps extends ItemTileViewPropsBase {
    childCount: number;
}

const FolderTileView = observer(function FolderTileView(props: FolderTileViewProps) {
    return (
        <ItemTileView
            {...props as ItemTileViewPropsBase}
            className={styles.tileContainer}
            onSelectedClassName={styles.tileSelected}
            shouldShowTileOverlay={true}>
            <i
                className={classNames(props.icon.large, styles.itemIcon)}
                data-is-focusable={false}
            />
        </ItemTileView>
    );
});
export default FolderTileView;
